// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8742) return "static/chunks/8742.7607805d35041a2e.js";
	if (chunkId === 3899) return "static/chunks/3899.ff251f5a3a20a3f1.js";
	if (chunkId === 6645) return "static/chunks/6645.879abb690f964b56.js";
	if (chunkId === 8865) return "static/chunks/8865.c16e6e04b4f6f740.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7753 ? "fc2f6fa8" : chunkId) + "-" + {"2294":"495c68544ec1c436","2565":"b538c8803087d531","3063":"2ecc1a098704cd50","4277":"b4ebc3b2b18cc0d8","7576":"9a10914f05b881ee","7753":"5b20e092bbb68530","7837":"63a407e16f420d2c"}[chunkId] + ".js";
};